import adminRequest, { clearH5AdminToken, getH5AdminToken, setH5AdminToken, setSchoolsActiveOrgId, clearSchoolsActiveOrgId } from '@/utils/h5-admin-request'

const PREFIX = '/signstore/h5admin/auth'
const H5_ADMIN_USER_KEY = 'h5_admin_user'

export function h5AdminLogin(data) {
  return adminRequest.post(PREFIX + '/login', data)
}

export function h5AdminGetCode() {
  return adminRequest.get(PREFIX + '/code')
}

export function h5AdminGetInfo() {
  return adminRequest.get(PREFIX + '/info')
}

export function h5AdminLogout() {
  return adminRequest.delete(PREFIX + '/logout')
}

export function getH5AdminUserCache() {
  try {
    const raw = window.sessionStorage.getItem(H5_ADMIN_USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function saveH5AdminLoginResult(res) {
  const payload = res && res.data != null ? res.data : res
  const authData = payload && payload.data != null ? payload.data : payload
  if (authData && authData.token) {
    setH5AdminToken(authData.token)
  }
  if (authData && authData.user) {
    try {
      window.sessionStorage.setItem(H5_ADMIN_USER_KEY, JSON.stringify(authData.user))
      syncSchoolsOrgFromUser(authData.user)
    } catch (e) {
      // ignore
    }
  }
  return authData
}

function syncSchoolsOrgFromUser(user) {
  if (!user) return
  if (user.schoolsPlatformAdmin) {
    return
  }
  if (user.schoolsOrgId) {
    setSchoolsActiveOrgId(user.schoolsOrgId)
  }
}

export function removeH5AdminSession() {
  clearH5AdminToken()
  clearSchoolsActiveOrgId()
  try {
    window.sessionStorage.removeItem(H5_ADMIN_USER_KEY)
  } catch (e) {
    // ignore
  }
}

export function hasH5AdminSession() {
  return !!getH5AdminToken()
}
